
const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ?]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const QUICKBOOK_FIELDS = [
  {
    id: "clientId",
    label: "Client ID",
    placeHolder: "Enter Client ID",
    type: "text",
    md: 12,
    // isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "clientSecret",
    label: "Client Secret",
    placeHolder: "Enter Client Secret",
    type: "text",
    md: 12,
    // isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "customerStrategy",
    label: "Customer Strategy",
    placeHolder: "Select",
    type: "select",
    // options: [
    //   { label: "Customer", value: "Customer" },
    //   { label: "Removal", value: "Removal" },
    // ],
    options:['Customer','Removal'],
    md: 12,
    // isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];

export const QUICKBOOK_DETAILS_FIELDS = [
  {
    id: "clientId",
    label: "Client ID",
    placeHolder: "Enter Client ID",
   type: "viewField",
    md: 12,
  },
  {
    id: "clientSecret",
    label: "Client Secret",
    placeHolder: "Enter Client Secret",
    type: "viewField",
    md: 12,
  },
  {
    id: "customerStrategy",
    label: "Customer Strategy",
    placeHolder: "Select",
   type: "viewField",
    md: 12,
  },
];